import DeliveriesRoute from 'cio/routes/base-deliveries';

export default class IndexRoute extends DeliveriesRoute {
  templateName = 'base/overview/drafts/index';

  setupController(controller, model) {
    controller.set('campaign', model.id);
    super.setupController(...arguments);
  }
}
